// extracted by mini-css-extract-plugin
export default {"content":"QQfdmNNu","_premium":"e417Kbod","expert":"PqxZNxo6","mobile":"mobile","title":"CneAWeVG","_capitalizeFirstLetter":"SL5Cijpb","subtitle":"fUBMHSX_"};